// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class XMLConstraint implements IConstraintModel {
  /**
   */
  get id(): string {
    return "Constraint.XML.InvalidFormat";
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must be well-formed XML";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  isValidXML(value: string): boolean {
    const oParser = new DOMParser();

    try {
      const oDom = oParser.parseFromString(value, "text/xml");

      if (oDom.querySelectorAll("parsererror").length > 0) {
        return false;
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  /**
   */
  validate(value: string): boolean {
    return this.isValidXML(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default XMLConstraint;
